'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _ThreadListItem = require('./ThreadListItem');

var _ThreadListItem2 = _interopRequireDefault(_ThreadListItem);

var _InfiniteScroll = require('conversations-internal-components/util/InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ThreadListInfiniteScroll = (0, _styledComponents2.default)(_InfiniteScroll2.default).withConfig({
  displayName: 'ThreadList__ThreadListInfiniteScroll'
})(_templateObject);

var ThreadList = _react2.default.createClass({
  displayName: 'ThreadList',

  propTypes: {
    botResponder: (0, _RecordPropType2.default)('Responder'),
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    initialResponder: (0, _RecordPropType2.default)('Responder').isRequired,
    onSelectThread: _react.PropTypes.func.isRequired,
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    responders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    threadList: _react.PropTypes.instanceOf(_immutable.List).isRequired
  },

  renderThreadList: function renderThreadList() {
    var _props = this.props,
        botResponder = _props.botResponder,
        chatHeadingConfig = _props.chatHeadingConfig,
        coloring = _props.coloring,
        initialResponder = _props.initialResponder,
        onSelectThread = _props.onSelectThread,
        potentialResponders = _props.potentialResponders,
        responders = _props.responders,
        threadList = _props.threadList;


    return threadList.map(function (thread) {
      var latestMessage = thread.latestMessage,
          threadId = thread.threadId,
          unseenCount = thread.unseenCount,
          channel = thread.channel;


      return _react2.default.createElement(_ThreadListItem2.default, {
        key: 'thread.' + threadId,
        coloring: coloring,
        latestMessage: latestMessage,
        potentialResponders: potentialResponders,
        chatHeadingConfig: chatHeadingConfig,
        initialResponder: initialResponder,
        onClick: function onClick() {
          return onSelectThread(channel);
        },
        unseenCount: unseenCount,
        thread: thread,
        responders: responders,
        botResponder: botResponder
      });
    });
  },
  render: function render() {
    return _react2.default.createElement(
      ThreadListInfiniteScroll,
      {
        className: 'thread-list',
        newestAtBottom: false,
        fetchMore: function fetchMore() {}
      },
      this.renderThreadList()
    );
  }
});

exports.default = ThreadList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/components/ThreadList.js
// module id = 972
// module chunks = 2 3